export const MEDIA_GALLERY_LIST_CACHE = 'CACHE.KEY.MEDIA_GALLERY.LIST'
